import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { UserProfile } from '../types/UserProfile';

interface UserProfileState {
  profile: UserProfile | null;
  loaded: boolean;
  loading: boolean;
}

const initialState: UserProfileState = {
  profile: null,
  loaded: false,
  loading: false,
};

const userProfileSlice = createSlice({
  name: 'userProfile',
  initialState,
  reducers: {
    setUserProfile: (state, action: PayloadAction<UserProfile>) => {
      state.profile = action.payload;
      state.loaded = true;
      state.loading = false;
    },
    clearUserProfile: (state) => {
      state.profile = null;
      state.loaded = false;
      state.loading = false;
    },
    updateUserName: (state, action: PayloadAction<string>) => {
      if (state.profile) {
        state.profile.properties['name'] = action.payload;
      }
    },
    setUserProfileLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});

export const { setUserProfile, clearUserProfile, updateUserName, setUserProfileLoading } =
  userProfileSlice.actions;
export default userProfileSlice.reducer;
